import { Controller } from "@hotwired/stimulus";
import * as Log from "web-ui/log"

// Connects to data-controller="popover"
export default class extends Controller {
  connect() {
    this.debug("Connect")
  }

  close() {
    this.debug("Close")
    this.element.hidePopover()
  }

  disconnect() {
    this.debug("Disconnect")
  }

  debug(message, data={}) {
    Object.assign(data, {
      id: this.element.id
    })

    Log.debug("Popover - " + message, data)
  }
}
